import { forwardRef } from 'react';
import cn from 'classnames';

import s from './BaseListCell.scss';

interface Props {
  className?: string;
  overflowHidden?: boolean;
}

const BaseListCell = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props>
>(({ className, overflowHidden, children }, ref) => (
  <div
    className={cn(
      s['list-item-cell'],
      overflowHidden && s['overflow-hidden'],
      className
    )}
    ref={ref}
  >
    {children}
  </div>
));
BaseListCell.displayName = 'BaseListCell';

export default BaseListCell;
